import React from "react";
import HourSelection, { type HourSelectionProps } from "./HourSelection";
import SchedulerTimes from "./SchedulerTimes";
import type { SchedulerRunnerData } from "../SchedulerUtils";

interface DailyRunnerProps {
  disabled?: boolean;
  data?: {
    times?: string[];
  };
  HourSelectionComponent?: React.ComponentType<HourSelectionProps>;
  onChange: (data: SchedulerRunnerData) => void;
}

const DailyRunner: React.FC<DailyRunnerProps> = ({
  disabled = false,
  data: { times = ["00:00"] } = {},
  HourSelectionComponent = HourSelection,
  onChange,
}) => {
  const onTimesChange = (times: string[]) => {
    onChange({
      type: "DAY",
      data: {
        interval: 1,
        times,
      },
    });
  };

  return (
    <SchedulerTimes
      initialTimes={times}
      onChange={onTimesChange}
      maxTimeSlots={2}
      HourSelectionComponent={HourSelectionComponent}
      label="Select Time(s)"
      data-testid={"scheduler-daily"}
      labelTop
      disabled={disabled}
    />
  );
};

export default DailyRunner;
